import { render, staticRenderFns } from "./FloatingPanel.vue?vue&type=template&id=7670ea3b&scoped=true"
import script from "./FloatingPanel.vue?vue&type=script&lang=js"
export * from "./FloatingPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatingPanel.vue?vue&type=style&index=0&id=7670ea3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670ea3b",
  null
  
)

export default component.exports